import { Grid } from "@mui/material";
import { TextInput } from "components/FormControls/TextInput";
import { Field, useField } from "formik";
import { useMessage } from "hooks/intl";
import { useEffect } from "react";
import { useStyles } from "../givePoints.styles";

export function GivePointsInternalBased({ fieldName }: { fieldName: string }) {
  const classes = useStyles();
  const { message } = useMessage();
  const [field, , helpers] = useField({ name: fieldName });

  const fieldValueState = field?.value || "";
  const { setValue } = helpers;
  useEffect(() => {
    setValue(fieldValueState);
    // eslint-disable-next-line
  }, [fieldValueState, fieldName]);

  return (
    <Grid item xs={12} className={classes.rowContainer}>
      <Field name={fieldName}>
        {() => {
          return (
            <TextInput
              className={classes.givePointsTextInput}
              data-test-id="effect-value"
              label={message({
                id: "rule",
              })}
              name={fieldName}
            />
          );
        }}
      </Field>
    </Grid>
  );
}
